"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILE_UPLOAD_DEFAULTS = void 0;
var FILE_UPLOAD_DEFAULTS = {
  LABEL: 'Attach File',
  ICON: 'AttachFileIcon',
  ID: 'airasia-fileupload'
};
exports.FILE_UPLOAD_DEFAULTS = FILE_UPLOAD_DEFAULTS;